import announcements from "@/frame/messages/mixins/announcements.js";

export default {
  // eslint-disable-next-line
  data() {
    return {};
  },
  mixins: [announcements],
  methods: {
    countItemOnCondition(condition, property, list) {
      let ctr = 0;
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (property === "basic.read" && list[i].basic.atn === false) {
          if (list[i].basic.read === condition) {
            ctr = ctr + 1;
          }
        }
        if (property === "basic.atn") {
          if (list[i].basic.atn === condition) {
            ctr = ctr + 1;
          }
        }
      }
      // update store
      return ctr;
    }
  }
};
